import { stopPropagation } from '$lib/utils/keyboard';

/** folds' focus-trap options as consumed by Overlay and PopOut. */
export interface LayerOptions {
	closeOnEscape: boolean;
	closeOnOutsideClick: boolean;
	initialFocus: boolean;
	returnFocus: boolean;
}

const preventDefault = (event: Event): void => event.preventDefault();

// bits-ui Dialog/Popover `Content` props equivalent to focus-trap's initialFocus /
// clickOutsideDeactivates / escapeDeactivates / returnFocusOnDeactivate.
export const layerProps = ({
	closeOnEscape,
	closeOnOutsideClick,
	initialFocus,
	returnFocus
}: LayerOptions) =>
	({
		interactOutsideBehavior: closeOnOutsideClick ? 'close' : 'ignore',
		onCloseAutoFocus: returnFocus ? undefined : preventDefault,
		onEscapeKeydown: (event: KeyboardEvent): void => {
			if (!closeOnEscape || !stopPropagation(event)) event.preventDefault();
		},
		onOpenAutoFocus: initialFocus ? undefined : preventDefault
	}) as const;
